import useSWR from "swr";

import { useApi } from "@touchtech/web-api-client";

import { createStoresSearchFiltersUrl } from "../../services/api";

type SearchStoreFiltersResponse = {
  countries: Array<{ id: string; label: string }>;
};

export const useSearchStoresFilters = () => {
  const api = useApi();
  const url = createStoresSearchFiltersUrl();

  const { data, error, isLoading } = useSWR(url, api.get);

  return {
    filters: data as SearchStoreFiltersResponse,
    isLoading,
    error,
  };
};
